export const SLICE_NAME = "clusterInfo";